module.exports = __webpack_public_path__ + "img/web_02_2.f540fd42.png";